<template>
  <div>
    <v-card elevation="0" class="px-7">
      <v-row dense align="center" justify="space-between">
        <v-col cols="12" sm="6">
          <h1 class="fs-16 primary--text font-weight-bold">
            Pending Approval
          </h1>
        </v-col>
        <v-col cols="12" sm="auto">
          <v-breadcrumbs class="app-breadcrumbs py-3" :items="breadcrumbs" />
        </v-col>
      </v-row>
      <v-tabs
        class="nav-tabs"
        v-model="tab"
        background-color="white"
        color="menuActive"
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          v-for="(item, index) in filters"
          :key="index"
          class="text-left px-0 d-block pt-3 mr-10"
          style="min-width: 120px !important; height:100%"
        >
          <span class="text-capitalize fs-12 font-weight-600 text-left">
            {{ item.name }}
          </span>
        </v-tab>
      </v-tabs>
    </v-card>

    <approval-tab-item v-if="tabItem" :item="tabItem" />
  </div>
</template>

<script>
import ApprovalTabItem from '@/components/SSHCP/ApprovalTabItem';

export default {
  components: { ApprovalTabItem },
  data: () => ({
    dialogFilter: false,
    tab: 0,
    filters: [
      {
        name: 'Approval Before B-Right'
      },
      {
        name: 'Approval After B-Right'
      }
    ],
    year: new Date().getFullYear(),
    breadcrumbs: [
      {
        text: 'SSHCP',
        to: '/'
      },
      {
        text: 'My Pending Approval',
        to: '/'
      }
    ]
  }),
  computed: {
    tabItem() {
      return this.filters[this.tab];
    }
  },
  methods: {}
};
</script>
